// Landing-page gallery: the feature slides, 1280 px wide WebP at 16:9. The files
// live in web/src/assets/shots/ (built by tools/build_web_assets.py from
// art/marketing/feature-slides/ in the client repo) and are imported here, so
// each ships under a content-hashed /assets/ name. The slides carry text, so
// each alt says what the slide says; `label` is the short name on its tab.
import jobs from '@/assets/shots/feature-jobs.webp';
import autofarm from '@/assets/shots/feature-autofarm.webp';
import mvp from '@/assets/shots/feature-mvp.webp';
import guilds from '@/assets/shots/feature-guilds.webp';
import party from '@/assets/shots/feature-party.webp';
import trade from '@/assets/shots/feature-trade.webp';
import chat from '@/assets/shots/feature-chat.webp';
import refine from '@/assets/shots/feature-refine.webp';
import cashshop from '@/assets/shots/feature-cashshop.webp';
import world from '@/assets/shots/feature-world.webp';
import skins from '@/assets/shots/feature-skins.webp';
import little from '@/assets/shots/feature-little.webp';

export type Shot = { src: string; label: string; alt: string; caption: string };

export const SHOTS: Shot[] = [
  {
    src: jobs,
    label: 'Jobs',
    alt: 'Every job you remember: character select cards for a Knight, an Acolyte and a Hunter, with twelve second-job icons',
    caption: 'Every classic job, from Swordman to Lord Knight',
  },
  {
    src: autofarm,
    label: 'Auto-farm',
    alt: 'Keep hunting while you rest: auto-farm runs while you are offline, with free time every day, more with VIP, and Auto Buff',
    caption: 'Auto-farm keeps hunting after you close the app',
  },
  {
    src: mvp,
    label: 'MVP',
    alt: 'Know when the boss is up: the in-game MVP Board listing the bosses that are alive now',
    caption: 'Boss timers on the in-game MVP Board',
  },
  {
    src: guilds,
    label: 'Guilds',
    alt: 'Raise a banner, take a castle: a pixel guild emblem, twenty classic castles and three siege nights a week',
    caption: 'Guild emblems, twenty castles and three siege nights a week',
  },
  {
    src: party,
    label: 'Party',
    alt: 'Bring the whole crew: the Party window with member HP and SP bars and actions for the selected member',
    caption: 'Parties of up to twelve, with shared EXP and loot',
  },
  {
    src: trade,
    label: 'Trade',
    alt: 'Deal face to face: the Trade window with your bag, your offer and your partner’s offer',
    caption: 'Trade face to face, open a shop or post a buying list',
  },
  {
    src: chat,
    label: 'Chat',
    alt: 'Talk while you fight: party and guild messages scrolling across the screen, a tagged chat log and slash commands',
    caption: 'Party and guild calls scroll across the screen mid-fight',
  },
  {
    src: refine,
    label: 'Refine',
    alt: 'Refine at the Anvil: the refine window showing a +7 Knife, its ore and blessing slots and a 60% success chance',
    caption: 'See your refine odds before you strike',
  },
  {
    src: cashshop,
    label: 'Cash shop',
    alt: 'A shop that plays fair: the in-game Cash Shop with boosts, rentals and costumes',
    caption: 'Boosts, rentals and costumes at fair prices',
  },
  {
    src: world,
    label: 'World',
    alt: 'Skies that change: day and night plus eleven kinds of event weather, from rain and snow to sakura petals and fireflies',
    caption: 'Day and night, plus event weather from storms to sakura',
  },
  {
    src: skins,
    label: 'Skins',
    alt: 'Pick your look: the Character window in the Classic, Sticker and Blockworks interface skins',
    caption: 'Four interface skins to choose from',
  },
  {
    src: little,
    label: 'Little things',
    alt: 'Small touches, everywhere: twelve small features, from walking to the nearest portal to loot that glows',
    caption: 'Small touches, from portal walking to glowing loot',
  },
];
